import React, {type ReactNode} from 'react';
import {SimpleArtifactImage} from 'app/components/my_profile/artifacts/image';
import {currencyItem, shopItemPrice} from 'app/utils/ShopItemPriceFormat';

export type ShopItemDetailsPreviewVariant = 'set' | 'other';

interface Props {
    artifact: unknown
    title: string
    currency: string
    cost_money: string | number
    cost_points: string | number
    actions: ReactNode
    meta?: ReactNode
    opening?: boolean
    previewVariant?: ShopItemDetailsPreviewVariant
}

const ShopItemDetailsHeader = ({
    artifact,
    title,
    currency,
    cost_money,
    cost_points,
    actions,
    meta,
    opening,
    previewVariant
}: Props): React.ReactElement => {
    const previewClassName = `shop-item-detail__preview ${previewVariant ? `shop-item-detail__preview--${previewVariant}` : ''}`;
    const headerClassName = `shop-item-detail__header ${opening ? 'shop-item-detail__header--opening' : ''}`;

    return <div className={headerClassName}>
        <div className="shop-item-detail__header-inner">
            <div className={previewClassName}>
                <SimpleArtifactImage artifact={artifact}/>
            </div>
            <div className="shop-item-detail__info">
                <div className="shop-item-detail__text">
                    <div className="shop-item-detail__heading">
                        <h2 className="shop-item-detail__title">{title}</h2>
                        {meta}
                    </div>
                    <div className="shop-item-detail__price">
                        {shopItemPrice({
                            cost_money: Number(cost_money),
                            cost_points: Number(cost_points),
                            currency: currencyItem(currency)
                        })}
                    </div>
                </div>
                {actions}
            </div>
        </div>
    </div>;
};

export default ShopItemDetailsHeader;
